import Vue from 'vue'
import VueRouter from 'vue-router'

import LoadingView from '../views/LoadingView.vue'
import TopView from '../views/TopView.vue'
import ErrorView from '../views/ErrorView.vue'
import MaintenanceView from '../views/MaintenanceView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'loading',
    component: LoadingView
  },
  {
    path: '/top',
    name: 'top',
    component: TopView
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: MaintenanceView
  },
  {
    path: '/error',
    name: 'error',
    component: ErrorView
  },
  {
    path: '*',
    name: 'allerror',
    component: ErrorView
  }
]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
